import _ from 'lodash';

export const _isAdmin = (roles) => {
  return _.find(roles, role => {return role.name === 'admin'});
};

export const _isDepartmentUser = (roles) => {
  return _.find(roles, role => {return role.name === 'departmentUserRole'});
};

export const formatNumber = (number, requiredDigits) => {
  if(requiredDigits === 1){
    return number.toString()
  }
  if(requiredDigits === 2) {
    if(number < 10){
      return ("0" + number).slice(-2);
    }
  }
  if(requiredDigits === 3) {
    if(number < 10){
      return ("00" + number).slice(-3);
    } else if(number < 100) {
      return ("0" + number).slice(-3);
    }
  }
  if(requiredDigits === 4) {
    if(number < 10){
      return ("000" + number).slice(-4);
    } else if(number < 100) {
      return ("00" + number).slice(-4);
    } else if(number < 1000) {
      return ("0" + number).slice(-4);
    }
  }

  return number.toString()
};

export const scrollToElement = (element) => {
  element.scrollIntoView(true);
};

export const getStoreType = (store) => {
  if (store.new) {
    return 'Νέο'
  }

  if (store.newComing) {
    return 'Υφιστάμενο'
  }

  if (store.old) {
    return 'Εξάμηνο'
  }
};



// WEBPACK FOOTER //
// ./src/helpers/functions.js